"use client"

import * as React from "react"
import { Moon, Sun } from "lucide-react"
import { useTheme } from "next-themes"
import { Button } from "../ui/button"
import { useSidebarUser, updateUserPreferences } from "../lib/auth"

export function ThemeToggle() {
  const { theme, setTheme } = useTheme()
  const user = useSidebarUser()
  const [mounted, setMounted] = React.useState(false)

  // No longer syncing DB theme to next-themes here; centralized in ThemeProvider/ThemeWatcher
  React.useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return (
      <Button variant="ghost" size="icon" className="h-9 w-9" disabled>
        <div className="h-4 w-4" />
      </Button>
    )
  }

  const toggleTheme = () => {
    const nextTheme = theme === "dark" ? "light" : "dark"
    setTheme(nextTheme)
    // No longer persisting to backend directly here; centralized in ThemeProvider/ThemeWatcher
  }

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      className="h-9 w-9 rounded-full"
    >
      {theme === "dark" ? (
        <Sun className="h-4 w-4 transition-all" />
      ) : (
        <Moon className="h-4 w-4 transition-all" />
      )}
      <span className="sr-only">Toggle theme</span>
    </Button>
  )
}

